import React, { useState } from "react";
import { Form, Button, InputGroup, Alert } from "react-bootstrap";

export default function ScannerManuel({ onScan, loading, mode }) {
    const [code, setCode] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (!code.trim()) {
            setError('Veuillez saisir un code');
            return;
        }
        
        setError('');
        onScan(code.trim());
        setCode('');
    };

    const handlePaste = (e) => {
        const pastedText = e.clipboardData.getData('text');
        if (pastedText) {
            setCode(pastedText);
            // Auto-submit après collage
            setTimeout(() => {
                if (pastedText.trim()) {
                    onScan(pastedText.trim());
                    setCode('');
                }
            }, 100);
        }
    };

    const getModeIcon = () => {
        switch(mode) {
            case 'entree': return 'ri-add-circle-line';
            case 'sortie': return 'ri-subtract-line';
            default: return 'ri-search-line';
        }
    };

    const getModeColor = () => {
        switch(mode) {
            case 'entree': return 'success';
            case 'sortie': return 'danger';
            default: return 'primary';
        }
    };

    return (
        <div className="p-3">
            <div className={`alert alert-${getModeColor()} mb-3`}>
                <i className={`${getModeIcon()} me-2`}></i>
                Mode: {mode === 'entree' ? 'Entrée' : mode === 'sortie' ? 'Sortie' : 'Recherche'}
            </div>

            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                    <Form.Label>Code-barres ou référence</Form.Label>
                    <InputGroup>
                        <InputGroup.Text>
                            <i className="ri-barcode-line"></i>
                        </InputGroup.Text>
                        <Form.Control
                            type="text"
                            value={code}
                            onChange={(e) => setCode(e.target.value)}
                            onPaste={handlePaste}
                            placeholder="Saisissez ou collez le code..."
                            disabled={loading}
                            autoFocus
                        />
                        <Button 
                            type="submit" 
                            variant={getModeColor()}
                            disabled={loading || !code.trim()}
                        >
                            {loading ? (
                                <span className="spinner-border spinner-border-sm" />
                            ) : (
                                <>
                                    <i className="ri-send-plane-line me-2"></i>
                                    Scanner
                                </>
                            )}
                        </Button>
                    </InputGroup>
                    <Form.Text className="text-muted">
                        Vous pouvez aussi coller directement un code (Ctrl+V)
                    </Form.Text>
                </Form.Group>
            </Form>

            {error && (
                <Alert variant="danger">
                    <i className="ri-error-warning-line me-2"></i>
                    {error}
                </Alert>
            )}

            {/* Raccourcis */}
            <div className="mt-4">
                <small className="text-muted d-block mb-2">Codes de test :</small>
                <div className="d-flex gap-2 flex-wrap">
                    <Button 
                        variant="outline-secondary" 
                        size="sm"
                        onClick={() => setCode('REF2026020001')}
                    >
                        Imprimante
                    </Button>
                    <Button 
                        variant="outline-secondary" 
                        size="sm"
                        onClick={() => setCode('REF001')}
                    >
                        Huile
                    </Button>
                    <Button 
                        variant="outline-secondary" 
                        size="sm"
                        onClick={() => setCode('REF002')}
                    >
                        Volailles
                    </Button>
                </div>
            </div>
        </div>
    );
}